import React from 'react';
import cn from 'classnames';
import { reduxForm, Field } from 'redux-form';
import SelectField from './SelectField';
import FormError from './FormError';
import { formatSaveStatus } from '../helpers/formatters';
import CheckboxField from './CheckboxField';
import DateTimePicker from './DateTimePicker';
import { can, permActions } from '../permissions';

let PlanForm = ({
  handleSubmit,
  error,
  saveStatus,
  upgradePlanLink,
  plans,
  subId,
  SubNav,
  heading,
  requestedPlan,
  showLockCheckbox,
  showForce,
  showExecutionDate,
  isModal,
  isBusiness,
  isQuick,
  refs,
  loggedInUser,
}) => {
  const showPrice = can(loggedInUser, permActions.VIEW_PRICES);
  const isLockedError =
    error &&
    error.details &&
    error.details[0] &&
    error.details[0].key === 'plan_locked';
  const plansToShow = plans.map((plan) => {
    if (showPrice) {
      return [plan.id, `${plan.name} - $${plan.price}`];
    } else {
      return [plan.id, plan.name];
    }
  });
  return (
    <div ref={refs}>
      {!isModal && (
        <React.Fragment>
          <h1>{heading}</h1>
          <SubNav />
        </React.Fragment>
      )}
      {requestedPlan ? <p>User has requested {requestedPlan} plan.</p> : ''}
      <form onSubmit={handleSubmit}>
        <Field
          component={SelectField}
          name="plan_id"
          label="Choose a plan"
          empty="None"
          options={plansToShow}
        />
        {showLockCheckbox && (
          <Field component={CheckboxField} name="plan_lock" label="Lock plan" />
        )}
        {showForce && (
          <Field component={CheckboxField} name="force" label="Force" />
        )}
        {showExecutionDate && (
          <Field
            component={DateTimePicker}
            name="execution_dt"
            label="Execution date"
            subText="Datetime in the UTC format"
            options={{ enableTime: true, minDate: 'today' }}
          />
        )}
        {error &&
          (upgradePlanLink && !isBusiness && !isQuick ? (
            <React.Fragment>
              <FormError error={error} />
              {!isLockedError && (
                <div>
                  To upgrade the current plan go here. —{' '}
                  <a href={upgradePlanLink(subId)}>Go here</a>
                </div>
              )}
            </React.Fragment>
          ) : (
            <FormError error={error} />
          ))}
        <br />
        <button
          className={cn({
            btn: true,
            'btn-primary': isModal,
            'btn-default': !isModal,
          })}
          disabled={saveStatus === 'PENDING'}
        >
          Save Plan
        </button>
        <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
      </form>
    </div>
  );
};

PlanForm = reduxForm({
  form: 'plan',
  enableReinitialize: true,
})(PlanForm);

export default PlanForm;
